import { render, staticRenderFns } from "./TaxPph4Verse2View.vue?vue&type=template&id=101d9aa0"
import script from "./TaxPph4Verse2View.vue?vue&type=script&lang=js"
export * from "./TaxPph4Verse2View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports